import { useContext } from 'react';
import { Url } from '@wix/da-url';
import { ThemeContext, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
export function useEmptyChatImage() {
    const currentTheme = useContext(ThemeContext);
    return currentTheme === ThemeOptions.DARK ? Url.staticCDNLink('eclipse/chat/no-chats-dark.svg') : Url.staticCDNLink('eclipse/chat/no-chats-light.svg');
}
